import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import { PaginationPayload, MembershipsResponse, WalletRequestsResponse } from './types'

const API_ENDPOINT = '/api/v1/membership'

const membershipApi = createApi({
  reducerPath: 'membershipApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['membershipApi'],
  endpoints: (builder) => ({
    getTrainerMemberships: builder.query<MembershipsResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/user_membership/?plan__sub_product_type=PR&search=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&ordering=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
    }),

    getWalletRequests: builder.query<WalletRequestsResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/transaction/?type=D&search=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&ordering=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
    }),

    getSellerSubscription: builder.query<MembershipsResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '', type = '' }) => ({
        url: `${API_ENDPOINT}/user_membership/?plan__sub_product_type=${type}&search=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&ordering=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
    }),

    approveWalletRequest: builder.mutation<void, string>({
      query: (uid) => ({
        url: `${API_ENDPOINT}/transaction/${uid}/approve/`,
        method: 'PATCH',
      }),
    }),
  }),
})

export const { useGetTrainerMembershipsQuery, useGetWalletRequestsQuery, useApproveWalletRequestMutation, useGetSellerSubscriptionQuery } = membershipApi
export default membershipApi
